module.exports = __webpack_public_path__ + "assets/media/evening.91dc3aca.mp3";